import React, { Component } from 'react'
import $ from 'jquery'
import './Modal.scss'

import { Icon } from '@components/shared/elements'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// actions
import * as SHARED_ACTION from '@store/shared/actions'

class Modal extends Component {

  componentDidMount() {
    document.addEventListener('keydown', this._escFunction.bind(this))

  }

  _escFunction(event) {
    if (event.keyCode === 27) {
      this.props.close()
    }
  }
  _backModal(modal, goback = false) {
    this.props.actions.setContactModalsStateByObj(this.props.contactModals, {
      [modal]: true,
      modalOpened: true,
      modalChat: false,
      modalCall: false,
      modalWhats: false,
      modalEmail: false,
      modalWelcome: false,
    })
    this.props.actions.optionsModals(goback)
    this.props.actions.highlightModal(this.props.highlightModal, {
      imovelId: '',
      imovelNome: '',
      imovelLocalizacao: '',
      idFacilita: '',
    })
  }
  render() {
    if (this.props.contactModals.modalOpened) {
      $('body').addClass('no-scroll')
    } else {
      $('body').removeClass('no-scroll')
    }
    return (
      <div className={`modal ${this.props.show ? 'visible' : 'hidden'} ${this.props.fullscreen ? 'fullscreen' : ''} ${this.props.extraClass ? `${this.props.extraClass}` : ''}`}>
        <div className='modal-content'>
          {this.props.goback &&
            <button className='go-back' onClick={() => this._backModal('modalOptions')}>
              <Icon icon='arrow-left' size='lg' />
            </button>
          }

          <button className='bt-close' onClick={this.props.close}>
            <span aria-hidden='true'>&times;</span>
          </button>
          {this.props.children}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    contactModals: state.shared.contactModals,
    optionsModals: state.shared.optionsModals,
    highlightModal: state.shared.highlightModal,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal)



// WEBPACK FOOTER //
// ./src/components/shared/elements/Modal/Modal.js